<script>
import moment from "@/utils/moment";
import dateMixin from "@/mixins/dateMixin";

export default {
  mixins: [dateMixin],
  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  methods: {
    sendDataToClipboard(text) {
      let el = document.createElement("input");
      el.value = text;

      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$toast.success("Informação copiada para a área de transferência.");
    }
  },

  computed: {
    fullName() {
      return this.professional.first_name + " " + this.professional.last_name;
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="header">
      <router-link :to="`profissionais/${professional.accountable.id}`">
        <img class="profile-img" :src="professional.profile.profile_picture" />
      </router-link>

      <div class="name">
        <span class="first-name">{{ professional.first_name }}</span>

        <span class="last-name">{{ professional.last_name }}</span>
      </div>

      <img
        class="copy"
        src="/static/copy.svg"
        v-on:click="sendDataToClipboard(fullName)"
      />
    </div>

    <div class="infos">
      <div class="content-info">
        <span><b>Email:</b> {{ professional.email }}</span>

        <img
          class="copy small"
          src="/static/copy.svg"
          v-on:click="sendDataToClipboard(professional.email)"
        />
      </div>

      <div class="content-info">
        <span><b>Cidade:</b> {{ professional.profile.city_name }}</span>
      </div>

      <div class="content-info">
        <span><b>CPF:</b> {{ professional.accountable.cpf }}</span>

        <img
          class="copy small"
          src="/static/copy.svg"
          v-on:click="sendDataToClipboard(professional.accountable.cpf)"
        />
      </div>

      <div class="content-info">
        <span><b>MEI:</b> {{ professional.accountable.mei || "n/a" }}</span>
      </div>

      <div class="content-info">
        <span
          ><b>Criado em:</b> {{ professional.created_at | formatDate }}</span
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
}

.card:not(:last-child) {
  margin-bottom: 8px;
}

.header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: solid 1px #dedede;
  position: relative;
}

.profile-img {
  height: 60px;
  width: 60px;
  margin-right: 12px;
  border-radius: 50%;
}

.name {
  width: 110px;
  display: flex;
  flex-direction: column;
}

.first-name {
  font-size: 18px;
  font-weight: 500;
}

.last-name {
  font-size: 14px;
  font-weight: 400;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  opacity: 0;
  transition: opacity 0.25s ease-out;
}

.infos {
  padding-top: 8px;
}

.content-info {
  font-size: 14px;
  position: relative;
  display: flex;
}

span {
  font-size: 14px;
  max-width: 90%;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.small {
  width: 18px;
  height: 18px;
}

.header:hover .copy,
.content-info:hover .copy {
  opacity: 0.75;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalTrainingFlow/components/Card.vue